import React from 'react';
import Matrix from '../../Matrix/Matrix';

const QuestionsPanel = ({index, moduleData, 
  org_rol, moduleAnswers, 
  setModuleAnswers, moduleErrors, 
  setModuleErrors, newpolicy, statusOfModule})=>{

   React.useEffect(()=>{
      const eleid = `${moduleData.cid}_${moduleData.module}_${moduleData.id}_${moduleData['questions'][0].id}`;
      document.getElementById(eleid)?.focus();
   },[moduleData]);

  return (
    moduleData?
    <div key={`ma${index}`} 
        role='region' 
        aria-label={newpolicy?'new policy':`edit ${moduleData.examTitle}`}>
          
      <Matrix json={moduleData}
      org_rol={org_rol}
      moduleAnswers={moduleAnswers}
      setModuleAnswers={setModuleAnswers}
      moduleErrors={moduleErrors}
      setModuleErrors={setModuleErrors}
      statusOfModule={statusOfModule}
      first={true}
      apcp={true}
      /></div>:null);


};

export default QuestionsPanel;